import type { CreativeImportSkippedBreakdown } from '../types/creative-import.types';

const SKIP_REASON_LABELS: Record<string, string> = {
  no_downloadable_asset: 'No downloadable asset',
  third_party_served: 'Third-party served',
  non_image: 'Non-image format',
};

export function formatSkipReason(reason: string): string {
  return SKIP_REASON_LABELS[reason] ?? reason.replace(/_/g, ' ');
}

export function formatSkippedBreakdown(skipped: CreativeImportSkippedBreakdown[]): string {
  if (!skipped.length) {
    return 'Nothing will be skipped.';
  }

  return skipped
    .filter((entry) => entry.count > 0)
    .map((entry) => `${entry.count} ${formatSkipReason(entry.reason).toLowerCase()}`)
    .join(', ');
}
